import { render } from "./BotanicalSources.vue?vue&type=template&id=ec19e212&scoped=true"
import script from "./BotanicalSources.vue?vue&type=script&lang=js"
export * from "./BotanicalSources.vue?vue&type=script&lang=js"

import "./BotanicalSources.vue?vue&type=style&index=0&id=ec19e212&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec19e212"]])

export default __exports__